export const RESET_REDUX = 'redux/RESET';
export const LOADER_SET = 'loader/SET';
export const NOTIFY_SET = 'notify/SET';
export const USER_SET = 'user/SET';
export const MENU_SET = 'menu/SET';
export const SELECT_CASE_DATE_SET = 'selectCaseDateSet/SET';
export const ONLINE_SET = 'online/SET';
export const SERVER_URL_SET = 'SERVER_URL/SET';
export const PRODUCTS_SET = 'Products/SET';
export const SCANNER_SET = 'Scanner/SET';
export const GO_BACK_SET = 'goBack/SET';
export const OTHER_CHARGE_SET = 'otherCharge/SET';
export const CASE_FILTER_SET = 'caseFilter/SET';
export const MISSING_DGRS_FILTER_SET = 'missingDgrsFilter/SET';
export const TEAM_SET = 'team/SET';
export const PREFERENCE_SET = 'preference/SET';
export const MISSING_POS_FILTER_SET = 'missingPosFilter/SET';
export const NOT_BILLED_FILTER_SET = 'notBilledFilter/SET';
export const BILLED_FILTER_SET = 'billedFilter/SET';
export const TABLE_NAME_SET = 'tableName/SET';
export const SELECTED_EXPRESS_SETS_SET = 'selectedExpressSets/SET';
export const LOT_SCANNER_SET = 'lotScanner/SET';
export const SETS_SEARCH_SET = 'setsSearch/SET';
export const SETS_LIST_STATE_STORAGE = 'setsListStateStorage/SET';
export const PREFERENCE_OPTIONS = 'preferenceOptions/SET';
export const SEARCH_BILLED_DATA_SET = 'searchBilledData/SET';
export const OFFICE_SETS_FILTER_SET = 'officeSetsFilter/SET';
export const SETS_FILTER_SET = 'setsFilter/SET';
export const EXPRESS_CARE_SETS_FILTER_SET = 'expressCareSetsFilter/SET';
export const NOT_BILLING_FILTER_SET = 'notBillingFilter/SET';
export const SEARCH_BILLED_CASE_COUNT_DATA_SET = 'searchBilledCaseCountData/SET';
export const CALENDAR_FILTER_SET = 'calendarFilter/SET';
export const SELECTED_SETS_PAYLOAD_SET = 'selectedSetsPayload/SET';
export const SEARCH_FILTER_SET = 'searchFilter/SET';
export const SCAN_INVENTORY_SET = 'scanInventory/SET';
export const SINGLE_SCAN_SESSION_SET = 'singleScanSession/SET';
export const INVENTORY_FILTER_SET = 'inventoryFilter/SET';
export const FIRST_LOGIN_SESSION_TOKEN_SET = 'firstLoginSessionToken/SET';
export const SCAN_INVENTORY_SCANNER_SET = 'scanInventoryScanner/SET';
export const VHN_PPC_OTHER_CHARGE_SET = 'vhnPpcOtherCharge/SET';
export const UPDATED_ROUTE_SET = 'updatedRoute/SET';
export const DERS_DETAILS_SET = 'dersDetails/SET';
export const CASE_DER_SET = 'caseDer/SET';
export const DER_FILTER_SET = 'derFilter/SET';
export const DER_SEARCH_FILTER_SET = 'derSearchFilter/SET';
export const DERS_PRODUCTS_SET = 'dersProducts/SET';
export const DERS_FILTER_RESULT_SET = 'dersFilterResult/SET';
export const VIEW_DERS_DETAILS_SET = 'viewDersDetails/SET';
export const IS_SHOW_BUTTONS_SET = 'isShowButtons/SET';
export const SELECT_CASE_ID_SET = 'selectCaseIdSet/SET';
export const AGGREGATE_PLAN_SET = 'aggregatePlanSet/SET';
export const NOTIFICATIONS_SET = 'notificationsSet/SET';
export const PREV_ROUTE_SET = 'prevRouteSet/SET';
export const SALES_FILTER_SET = 'salesFilterSet/SET';
export const SETS_TO_MOVE_SET = 'setsToMoveSet/SET';
export const DER_MODAL_SET = 'derModalSet/SET';
export const SALES_YTD_SET = 'salesYTDSet/SET';
export const READ_ONLY_PRODUCT_NOTES_SET = 'readOnlyProductNotesSet/SET';
export const READ_CASE_DATA_SET = 'readCaseDataSet/SET';
export const AUTO_LOGIN_DATA_SET = 'autoLoginData/SET';
export const SURGEONNOTE_SET = 'surgeonNote/SET';
export const SAVED_SCROLL_POSTION_SET = 'savedScrollPosition/SET';
export const THEME_COLOR_SET = 'themeColorSet/SET';
export const THEME_DETECT_COLOR_SET = 'themeDetectColorSet/SET';
export const THEME_COLOR_NUMBER_SET = 'themeColorNumberSet/SET';
export const CALENDAR_MONTH_END_DATE_SET = 'calendarMonthEndDateSet/SET';
export const BROWSER_DETECT_SET = 'browserDetectSet/SET';

export const resetRedux = () => ({
  type: RESET_REDUX,
});

export const loaderSet = (data) => ({
  type: LOADER_SET,
  data,
});

export const notifySet = (state) => ({
  type: NOTIFY_SET,
  state,
});

export const userSet = (user) => ({
  type: USER_SET,
  user,
});

export const menuSet = (data) => ({
  type: MENU_SET,
  data
});

export const selectCaseDateSet = (data) => ({
  type: SELECT_CASE_DATE_SET,
  data
});

export const onlineSet = (data) => ({
  type: ONLINE_SET,
  data
});

export const serverUrlSet = (data) => ({
  type: SERVER_URL_SET,
  data
});

export const productsSet = (data) => ({
  type: PRODUCTS_SET,
  data
});

export const scannerSet = (data) => ({
  type: SCANNER_SET,
  data
});

export const goBackSet = (data) => ({
  type: GO_BACK_SET,
  data
});

export const otherChargeSet = (data) => ({
  type: OTHER_CHARGE_SET,
  data
});

export const caseFilterSet = (data) => ({
  type: CASE_FILTER_SET,
  data
});

export const teamSet = (data) => ({
  type: TEAM_SET,
  data
});

export const preferenceSet = (data) => ({
  type: PREFERENCE_SET,
  data
});

export const missingDgrsFilterSet = (data) => ({
  type: MISSING_DGRS_FILTER_SET,
  data
});

export const missingPosFilterSet = (data) => ({
  type: MISSING_POS_FILTER_SET,
  data
});

export const notBilledFilterSet = (data) => ({
  type: NOT_BILLED_FILTER_SET,
  data
});

export const billedFilterSet = (data) => ({
  type: BILLED_FILTER_SET,
  data
});

export const tableNameSet = (data) => ({
  type: TABLE_NAME_SET,
  data
});

export const selectedExpressSetsSet = (data) => ({
  type: SELECTED_EXPRESS_SETS_SET,
  data
});

export const lotScannerSet = (data) => ({
  type: LOT_SCANNER_SET,
  data
});

export const setsSearchSet = (data) => ({
  type: SETS_SEARCH_SET,
  data
});

export const setsListStateStorageSet = (data) => ({
  type: SETS_LIST_STATE_STORAGE,
  data
});

export const preferenceOptionsSet = (data) => ({
  type: PREFERENCE_OPTIONS,
  data
});

export const searchBilledDataSet = (data) => ({
  type: SEARCH_BILLED_DATA_SET,
  data
});

export const officeSetsFilterSet = (data) => ({
  type: OFFICE_SETS_FILTER_SET,
  data
});

export const expressCareSetsFilterSet = (data) => ({
  type: EXPRESS_CARE_SETS_FILTER_SET,
  data
});

export const setsFilterSet = (data) => ({
  type: SETS_FILTER_SET,
  data
});

export const notBillingFilterSet = (data) => ({
  type: NOT_BILLING_FILTER_SET,
  data
});

export const searchBilledCaseCountDataSet = (data) => ({
  type: SEARCH_BILLED_CASE_COUNT_DATA_SET,
  data
});

export const calendarFilterSet = (data) => ({
  type: CALENDAR_FILTER_SET,
  data
});

export const selectedSetsPayloadSet = (data) => ({
  type: SELECTED_SETS_PAYLOAD_SET,
  data
});

export const searchFilterSet = (data) => ({
  type: SEARCH_FILTER_SET,
  data
});

export const scanInventorySet = (data) => ({
  type: SCAN_INVENTORY_SET,
  data
});

export const singleScanSessionSet = (data) => ({
  type: SINGLE_SCAN_SESSION_SET,
  data
});

export const inventoryFilterSet = (data) => ({
  type: INVENTORY_FILTER_SET,
  data
});

export const firstLoginSessionTokenSet = (data) => ({
  type: FIRST_LOGIN_SESSION_TOKEN_SET,
  data
});

export const scanInventoryScannerSet = (data) => ({
  type: SCAN_INVENTORY_SCANNER_SET,
  data
});

export const vhnPpcOtherChargeSet = (data) => ({
  type: VHN_PPC_OTHER_CHARGE_SET,
  data
});

export const updatedRouteSet = (data) => ({
  type: UPDATED_ROUTE_SET,
  data
});

export const dersDetailsSet = (data) => ({
  type: DERS_DETAILS_SET,
  data
});

export const caseDerSet = (data) => ({
  type: CASE_DER_SET,
  data
});

export const derFilterSet = (data) => ({
  type: DER_FILTER_SET,
  data
});

export const derSearchFilterSet = (data) => ({
  type: DER_SEARCH_FILTER_SET,
  data
});

export const dersProductsSet = (data) => ({
  type: DERS_PRODUCTS_SET,
  data
});

export const dersFilterResultSet = (data) => ({
  type: DERS_FILTER_RESULT_SET,
  data
});

export const viewDersDetailsSet = (data) => ({
  type: VIEW_DERS_DETAILS_SET,
  data
});

export const isShowButtonSet = (state) => ({
  type: IS_SHOW_BUTTONS_SET,
  state
});

export const selectCaseIdSet = (data) => ({
  type: SELECT_CASE_ID_SET,
  data
});

export const aggregatePlanSet = (data) => ({
  type: AGGREGATE_PLAN_SET,
  data
});

export const notificationsSet = (data) => ({
  type: NOTIFICATIONS_SET,
  data
});

export const prevRouteSet = (data) => ({
  type: PREV_ROUTE_SET,
  data
});

export const salesFilterSet = (data) => ({
  type: SALES_FILTER_SET,
  data
});

export const setsToMoveSet = (data) => ({
  type: SETS_TO_MOVE_SET,
  data
});

export const derModalSet = (data) => ({
  type: DER_MODAL_SET,
  data
});

export const salesYTDSet = (data) => ({
  type: SALES_YTD_SET,
  data
});

export const readOnlyProductNotesSet = (data) => ({
  type: READ_ONLY_PRODUCT_NOTES_SET,
  data
});

export const readCaseDataSet = (data) => ({
  type: READ_CASE_DATA_SET,
  data
});

export const autoLoginDataSet = (data) => ({
  type: AUTO_LOGIN_DATA_SET,
  data
});

export const surgeonNoteSet = (data) => ({
  type: SURGEONNOTE_SET,
  data
});

export const savedScrollPositionSet = (data) => ({
  type: SAVED_SCROLL_POSTION_SET,
  data
});

export const themeColorSet = (data) => ({
  type: THEME_COLOR_SET,
  data
});

export const themeDetectColorSet = (data) => ({
  type: THEME_DETECT_COLOR_SET,
  data
});

export const themeColorNumberSet = (data) => ({
  type: THEME_COLOR_NUMBER_SET,
  data
});

export const calendarMonthEndDateSet = (data) => ({
  type: CALENDAR_MONTH_END_DATE_SET,
  data
});

export const browserDetectSet = (data) => ({
  type: BROWSER_DETECT_SET,
  data
});
